import { default as Account } from './ContentAccount/ContentAccount.container';
import { default as Api } from './ContentApi/ContentApi.container';
import { default as Docs } from './ContentDocs/ContentDocs.container';
import { default as Events } from './ContentEvents/ContentEvents.container';
import { default as GeneratorDetails } from './ContentGeneratorDetails/ContentGeneratorDetails.container';
import { default as Generators } from './ContentGenerators/ContentGenerators.container';
import { default as HireCreator } from './ContentHireCreator/ContentHireCreator.container';
import { default as MadeWithSloyd } from './ContentMadeWithSloyd/ContentMadeWithSloyd.container';
import { default as Pricing } from './ContentPricing/ContentPricing.container';
import { default as Projects } from './ContentProjects/ContentProjects.container';
import { default as Settings } from './ContentSettings/ContentSettings.container';
import { default as Usage } from './ContentUsage/ContentUsage.container';
import { default as WhatsNew } from './ContentWhatsNew/ContentWhatsNew.container';

export const content = {
  Account,
  Api,
  GeneratorDetails,
  Pricing,
  Docs,
  Events,
  Generators,
  HireCreator,
  MadeWithSloyd,
  Projects,
  Settings,
  Usage,
  WhatsNew,
};
